import { render, staticRenderFns } from "./FileUploadTest3.vue?vue&type=template&id=481a4d72&"
import script from "./FileUploadTest3.vue?vue&type=script&lang=js&"
export * from "./FileUploadTest3.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadTest3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports